import { Typography, Breadcrumbs, Link, NavigateNextIcon } from 'src/components';
import { useNavigate } from 'react-router-dom';

export default function HandbookBreadcrumbs({category, subcategory, textColor = 'text.secondary'}) {
    const navigate = useNavigate();

    const formatCategoryName = (name) => {
        return name?.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ') || '';
    };

    return (
        <Breadcrumbs 
            spacing={10}
            separator={<NavigateNextIcon 
                            fontSize="small" 
                            sx={{ 
                                color: textColor, 
                                margin: '0 -3px' }} />}>

                <Link 
                    onClick={() => navigate('/handbook')}
                    style={{ 
                        cursor: 'pointer',
                        textDecoration: 'none', 
                        color: textColor
                    }}
                    >
                    <Typography 
                        variant="subtitle1"
                        color="inherit">
                        Handbook
                    </Typography>
                </Link>

                <Link 
                    onClick={() => navigate(`/handbook/${category}`)}
                    color="inherit" 
                    sx={{ textDecoration: 'none', cursor: 'pointer' }}>

                        <Typography 
                            variant="subtitle1"
                            color={textColor}
                            fontWeight={ subcategory === undefined ? 600 : ''}>
                            {formatCategoryName(category)}
                        </Typography>
                </Link>

                {subcategory && (
                    <Typography 
                        variant="subtitle1"
                        color={textColor} 
                        fontWeight={600} 
                        sx={{cursor: 'pointer'}}>
                        {formatCategoryName(subcategory)}
                    </Typography>
                )}

        </Breadcrumbs>
    );
}